/**
 * Why an order's contract does not let it be invoiced, or null when it does —
 * the same rule, line for line, as the backend's
 * `services/invoices/contract-gate.js`. The server decides; this only keeps
 * the order page's button and hints in step with it.
 *
 * The contract is the order's main file (`files[0]`, the oldest). Read top to
 * bottom; the first line that applies decides.
 */
export type ContractBlockReason = "not_signed" | "annulled";

export function contractBlockReason(
  order: { contractDeferred?: boolean },
  mainFile: { isSigned?: boolean; annulledAt?: number | null } | undefined
): ContractBlockReason | null {
  // A signed contract decides on its own: billable until it is annulled.
  if (mainFile?.isSigned) return mainFile.annulledAt ? "annulled" : null;
  // No signed contract, and nobody said one is coming later.
  if (!order.contractDeferred) return "not_signed";
  // "Contract will be signed later": billable while the contract is missing or
  // still being signed, but not once it has been voided.
  if (mainFile?.annulledAt) return "annulled";
  return null;
}
